import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Auth, onAuthStateChanged, User } from '@angular/fire/auth';

function waitForUser(auth: Auth): Promise<User | null> {
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub(); // wichtig, damit der Listener entfernt wird
      resolve(user);
    });
  });
}

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const auth = inject(Auth);

  return from(waitForUser(auth)).pipe(
    switchMap(user => {
      return from(user?.getIdToken() || Promise.resolve(null));
    }),
    switchMap((token: string | null) => {
      if (token) {
        req = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
      }
      return next(req);
    })
  );
};